import { Url } from './constantUrl';
import { makeApiCall } from './makeApiCall';
import {
    CREATE_USER_REQUEST,
    CREATE_USER_SUCCESS,
    CREATE_USER_FAILURE,
    FETCH_EMPLOYEE_REQUEST,
    FETCH_EMPLOYEE_SUCCESS,
    FETCH_EMPLOYEE_FAILURE,
    USER_DETAIL_REQUEST,
    USER_DETAIL_SUCCESS,
    USER_DETAIL_FAILURE,
    DELETE_USER_REQUEST,
    DELETE_USER_SUCCESS,
    DELETE_USER_FAILURE,
    UPDATE_USER_REQUEST,
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAILURE,
    TOGGLE_USER_STATUS_SUCCESS,
    TOGGLE_USER_STATUS_FAILURE
} from './types';

// Create User Action
export const createUserAction = (userData) => async (dispatch) => {
    return makeApiCall({
        method: 'POST',
        endpoint: Url.CREATE_USER,
        data: userData,
        dispatch,
        requestType: CREATE_USER_REQUEST,
        successType: CREATE_USER_SUCCESS,
        failureType: CREATE_USER_FAILURE,
    });
};

// Action to fetch User data
export const fetchUserList = (roleId = '', page = 1, pageSize) => async (dispatch) => {
    const endpoint = roleId
        ? `${Url.USER_LIST}?search_data=${roleId}`
        : Url.USER_LIST;

    return makeApiCall({
        method: 'GET',
        endpoint,
        dispatch,
        requestType: FETCH_EMPLOYEE_REQUEST,
        successType: FETCH_EMPLOYEE_SUCCESS,
        failureType: FETCH_EMPLOYEE_FAILURE,
        params: {
            page,
            page_size: pageSize,
        },
    });
};

//Delete User
export const deleteUserAction = (userId) => async (dispatch) => {
    const endpoint = `${Url.DELETE_USER}/${userId}`;

    return makeApiCall({
        method: 'DELETE',
        endpoint,
        dispatch,
        requestType: DELETE_USER_REQUEST,
        successType: DELETE_USER_SUCCESS,
        failureType: DELETE_USER_FAILURE,
    });
};

//get user details for update
export const getUserDetailAction = (userId) => async (dispatch) => {
    const endpoint = `${Url.GET_USER_DETAILS}/${userId}`;

    return makeApiCall({
        method: 'GET',
        endpoint,
        dispatch,
        requestType: USER_DETAIL_REQUEST,
        successType: USER_DETAIL_SUCCESS,
        failureType: USER_DETAIL_FAILURE,
    });
};

//update user
export const updateUserAction = (userId, payload) => async (dispatch) => {
    const endpoint = `${Url.UPDATE_USER}/${userId}`;

    return makeApiCall({
        method: 'PUT',
        endpoint,
        data: payload,
        dispatch,
        requestType: UPDATE_USER_REQUEST,
        successType: UPDATE_USER_SUCCESS,
        failureType: UPDATE_USER_FAILURE,
    });
};

//switch toggle for user
export const toggleUserStatusAction = (userId, isActive) => async (dispatch) => {
    const endpoint = `${Url.USER_ACTIVATE_DEACTIVATE_SWITCH}/${userId}`;
    const data = { is_active: isActive };
    return await makeApiCall({
        method: 'POST',
        endpoint,
        data: data,
        dispatch,
        requestType: '',
        successType: TOGGLE_USER_STATUS_SUCCESS,
        failureType: TOGGLE_USER_STATUS_FAILURE,
    });
};